import { handle } from 'redux-pack';
import { Action } from '../../../types/actions';
import {
	ADD_SURVEY,
	GET_SURVEYS,
	UPDATE_SURVEY,
} from '../../actions/admin/surveys';
import { Survey } from '../../../types/working-model';

export interface SurveysState {
	surveys: Survey[];
}

const initialState: SurveysState = {
	surveys: [],
};

export default function SurveysReducer(
	state: SurveysState = initialState,
	action: Action
): SurveysState {
	switch (action.type) {
		case GET_SURVEYS: {
			return handle(state, action, {
				success: (state) => ({ ...state, surveys: action.payload }),
			});
		}
		case ADD_SURVEY: {
			return { ...state, surveys: [action.payload, ...state.surveys] };
		}
		case UPDATE_SURVEY: {
			return {
				...state,
				surveys: state.surveys.map((survey) => {
					if (survey.survey === action.payload.survey) return action.payload;
					return survey;
				}),
			};
		}
		default:
			return state;
	}
}
